/* Lo stato dell'archivio di /report, e gli indirizzi che lo portano.

   Modulo senza direttiva e senza dipendenze dal server: lo leggono sia la
   pagina (Server Component) sia la barra di ricerca (client). Le costanti
   che il server legge non possono stare in un file «use client» (vedi
   LEARNINGS, `LEAD_DISPACCI`).

   La forma ricalca lib/editoriali-raccolta.ts, che è la stessa raccolta
   con un'altra misura di pagina: testo, filtri e pagina nell'indirizzo,
   e ogni cambio di filtro riporta a pagina 1. */

export const REPORT_PATH = "/report";

/** L'id della sezione dell'archivio: ci si torna a ogni cambio di pagina
 *  o di filtro (vedi <AllaSezione>). */
export const ANCORA_ARCHIVIO = "archivio";

/** Cinque dossier per pagina, più la carta dei servizi al sesto posto:
 *  due righe da tre sul desktop (consegna del 01/10/2026). La carta non è
 *  un dossier e non entra nel conto. */
export const REPORT_PER_PAGINA = 5;

export type StatoReport = { q: string; cat: string; place: string; page: number };

type SP = { [key: string]: string | string[] | undefined };

function first(v: string | string[] | undefined): string {
  return (Array.isArray(v) ? v[0] : v)?.trim() ?? "";
}

export function leggiStatoReport(sp: SP): StatoReport {
  const n = parseInt(first(sp.page) || "1", 10);
  return {
    q: first(sp.q),
    cat: first(sp.cat),
    /* `?area=` era il filtro geografico della versione precedente: un
       indirizzo salvato con quel parametro continua a filtrare. */
    place: first(sp.place) || first(sp.area),
    page: Number.isFinite(n) && n > 0 ? n : 1,
  };
}

/** L'indirizzo dell'archivio con qualche cambio. Qualunque cambio che non
 *  sia la sola pagina riporta a pagina 1: una ricerca nuova non comincia
 *  dalla terza pagina di quella di prima. */
export function hrefReport(s: StatoReport, cambi: Partial<StatoReport> = {}): string {
  const soloPagina = Object.keys(cambi).every((k) => k === "page");
  const n: StatoReport = { ...s, ...cambi, page: soloPagina ? cambi.page ?? s.page : 1 };
  const usp = new URLSearchParams();
  if (n.q) usp.set("q", n.q);
  if (n.cat) usp.set("cat", n.cat);
  if (n.place) usp.set("place", n.place);
  if (n.page > 1) usp.set("page", String(n.page));
  const qs = usp.toString();
  return qs ? `${REPORT_PATH}?${qs}` : REPORT_PATH;
}

export const conFiltroReport = (s: StatoReport) => s.q !== "" || s.cat !== "" || s.place !== "";

export const it = (n: number) => n.toLocaleString("it-IT");
